import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
var useMount = function useMount(effect) {
  return useEffect(effect, []);
};

export { useMount as default };
//# sourceMappingURL=index.js.map
